import { useQuery } from "@apollo/client";
import { GET_DASHBOARD } from "../apollo/queries";
import { getSelectedStoreDetails } from "../utils/helperFunctions";

const useDashboard = (year) => {
  const { loading, error, data, refetch } = useQuery(GET_DASHBOARD, {
    variables: {
      //   input: {
      storeId: getSelectedStoreDetails("id"),
      year: year,
      todayDate: "2025-06-13",
      month: "06",
      //   },
    },
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("Error While Getting Dashboard", error);
  }

  console.log("phuppo ki ankh", data?.storeDashboard);
  

  return {
    values: {
      storeDashboard: data?.storeDashboard || [],
      loading,
    },
    refetch,
  };
};

export default useDashboard;
